import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { useAdminOrderStore } from '@features/admin/orders/useAdminOrderStore.ts';
import OrdersPage from '@features/admin/orders/OrdersPage.tsx';
import { OrderStatus } from '@api/generated/portal-be-admin';

const adminOrdersSearchSchema = z.object({
  portalId: z.coerce.number().optional(),
  status: z.nativeEnum(OrderStatus).optional(),
  orderNumber: z.string().optional(),
  ecid: z.string().optional(),
  supplierId: z.coerce.number().optional(),
  customerId: z.coerce.number().optional(),
  deliveryFrom: z.string().optional(),
  deliveryTo: z.string().optional(),
  createdFrom: z.string().optional(),
  createdTo: z.string().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminOrdersSearch = z.infer<typeof adminOrdersSearchSchema>;

export const Route = createFileRoute('/admin/orders/')({
  validateSearch: search => adminOrdersSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { portalId, status, orderNumber, ecid, supplierId, customerId, deliveryFrom, deliveryTo, createdFrom, createdTo, page, size } =
      ctx.search;
    useAdminOrderStore.getState().loadOrders({
      portalId,
      status,
      orderNumber,
      ecid,
      supplierId,
      customerId,
      deliveryFrom,
      deliveryTo,
      createdFrom,
      createdTo,
      page: page || 1,
      size: size || 20,
    });
  },
});

function RouteComponent() {
  return <OrdersPage />;
}
